<!-- 知识产权研究院首页 -->
<template>
	<div>
		<headTop></headTop>
		<!-- logo区域 -->
		<logo-head></logo-head>
		<!-- 导航菜单 -->
		<nav-head></nav-head>
		<!-- banner图 -->
		<banner></banner>
		<!-- 主页主体 -->
		<div class="homeContent">
			<!-- 研究院简介 -->
			<div class="irpiDesc">
				<span class="title">研究院简介</span>
				<div class="mt-3" v-html="ipriDesc">
				</div>
			</div>
			<!-- 行业资讯 -->
			<div class="news">
				<!-- 左侧图片 -->
				<div class="leftImg">
					<img :src="leftLogoImg" height="450">
				</div>
				<!-- 右侧新闻列表 -->
				<div class="rightNewsList">
					<!-- 中央主体 -->
					<div class="centerNewsList">
						<!-- 标题 -->
						<span class="title">行业资讯</span>
						<!-- 新闻列表 -->
						<div class="mt-3">
							<div v-for="(item,index) in newsList" :key="index" class="listArr">
								<span style="cursor: pointer;" @click="goDetail(item)" :title="item.name">
									{{item.name.length > 24 ? item.name.substr(0,24) + '...' : item.name}}
								</span>
							</div>
						</div>
						<el-button type="primary" @click="goLink('/news')" class="mt-3" color="#2c68ff" size="small">>查看更多</el-button>
					</div>
				</div>
				<!-- 右侧装饰条 -->
				<div style="width: 20px;height:350px;background-color: #2c68ff;position: absolute;right:-60px;top:50px;"></div>
			</div>
			<!-- 服务内容 -->
			<div class="seviceContent">
				<span class="title">服务内容</span>
				<!-- 卡片列表 -->
				<div class="mt-4 d-flex">
					<div class="cardList" @click="goLink('/finance')">
						<img src="./img/home/service_jinrong.jpg">
						<!-- 底部标题 -->
						<div class="bottomTitle text-center" style="background-color: #dc732c;">
							<span class="text-white">金融服务</span>
						</div>
					</div>
					<div class="cardList" @click="goLink('/intellectualProperty')">
						<img src="./img/home/service_zhichantuoguan.jpg">
						<!-- 底部标题 -->
						<div class="bottomTitle text-center" style="background-color: #50AD8F;">
							<span class="text-white">知识产权托管</span>
						</div>
					</div>
					<div class="cardList" @click="goLink('/patentNav')">
						<img src="./img/home/service_zhuanli.jpg">
						<!-- 底部标题 -->
						<div class="bottomTitle text-center" style="background-color: #6960C3;">
							<span class="text-white">专利导航</span>
						</div>
					</div>
					<div class="cardList"  @click="goLink('/personnel')">
						<img src="./img/home/servive_rencai.jpg">
						<!-- 底部标题 -->
						<div class="bottomTitle text-center" style="background-color: #3980C6;">
							<span class="text-white">人才培养</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- footer -->
		<Footer :bgColor="'#2c68ff'"></Footer>
	</div>
</template>

<script>
	import headTop from './components/headerTop/headerTop.vue'
	import logoHead from './components/logoHead/logoHead.vue'
	import navHead from './components/navHead/navHead.vue'
	import banner from './components/banner/banner.vue'
	import Footer from './components/footer/footer.vue'
	export default{
		components: {
			logoHead,
			headTop,
			navHead,
			banner,
			Footer
		},
		data() {
			return {
				ipriDesc:'',
				leftLogoImg:'',
				newsList:[]
			}
		},
		mounted() {
			this.getIpriDesc()
			this.getNews()
			this.getLeftLogoImg()
		},
		methods: {
			// 进入页面公共方式
			goLink(linkUrl){
				let routeData = this.$router.resolve({
					path:linkUrl
				})
				window.open(routeData.href, '_blank');
			},
			// 查询研究院简介
			getIpriDesc(){
				let vm = this
				vm.axios.get('/api/irpi/sys/findIntroduce').then(res=>{
					vm.ipriDesc = res.data.data
				})
			},
			// 查询行业资讯
			getNews(){
				let vm = this
				vm.axios.get('/api/irpi/industry/information/findIndustryInformationHome').then(res=>{
					vm.newsList = res.data.data
				})
			},
			// 左侧logo图片
			getLeftLogoImg(){
				let vm = this
				vm.axios.get('/api/material/findMaterial').then(res => {
					vm.leftLogoImg = res.data.data.industryUrl
				})
			},
			// 进入详情页
			goDetail(item){
				if(item.reprintMark){
					window.open(item.reprintUrl, '_blank');
				}
				let routeData = this.$router.resolve({
					path:'/irpiNewsDetail',
					query:{
						id:item.id,
						mbx:'行业资讯',
						mbxLink:'/news',
						newsType:'information'
					}
				})
				window.open(routeData.href, '_blank');
			}
		},
	}
</script>

<style scoped>
	.homeContent{
		width: 1160px;
		min-height: 800px;
		margin: 0 auto;
		margin-top: 20px;
		margin-bottom: 20px;
	}
	.homeContent .irpiDesc{
		margin-top:50px;
	}
	.homeContent .irpiDesc .title{
		font-size: 20px;
		font-weight: bold;
	}
	.homeContent .irpiDesc p{
		color: #666;
		font-size: 16px;
		line-height:2em;
	}
	/* 行业资讯 */
	.homeContent .news{
		width: 1100px;
		height: 450px;
		margin-top:100px;
		position: relative;
	}
	/* 左侧图片 */
	.homeContent .news .leftImg{
		width:600px;
		height:450px;
		background-color: #f8f8f8;
	}
	/* 右侧新闻列表 */
	.homeContent .news .rightNewsList{
		width: 520px;
		height: 400px;
		position: absolute;
		left: 620px;
		top:25px;
		background-color: #fff;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04)
	}
	.homeContent .news .rightNewsList .centerNewsList{
		width: 430px;
		height: 350px;
		margin-left:50px;
		margin-top: 25px;
	}
	.homeContent .news .rightNewsList .centerNewsList .title{
		font-size: 20px;
		font-weight: bold;
	}
	.homeContent .news .rightNewsList .centerNewsList .listArr span{
		font-size: 16px;
		line-height:36px;
		color: #888;
	}
	/* 服务内容 */
	.homeContent .seviceContent{
		width: 1160px;
		min-height: 300px;
		margin-top:100px;
		margin-bottom:70px;
	}
	.homeContent .seviceContent .title{
		font-size: 20px;
		font-weight: bold;
	}
	/* 卡片列表 */
	.homeContent .seviceContent .cardList{
		width:280px;
		height: 260px;
		position: relative;
		margin-right:20px;
		cursor: pointer;
	}
	/* 底部标题 */
	.homeContent .seviceContent .cardList .bottomTitle{
		width: 280px;
		height: 80px;
		position: absolute;
		bottom: 0;
	}
	.homeContent .seviceContent .cardList .bottomTitle span{
		line-height: 80px;
		font-size: 20px;
	}
</style>
